import axios from 'axios';

// const https = require('https');

// const agent = new https.Agent({ rejectUnauthorized: false });

// Produção: same-origin /api → Apache .htaccess faz proxy para 186.248.139.10:3339
// Local: backend direto na 3339
export const baseUrl = process.env.NODE_ENV === 'production'
  ? 'https://unijob.unimedvarginha.coop.br/api'
  : 'http://localhost:3339';

const config = axios.create({
  baseURL: baseUrl,
  // Timeout aumentado temporariamente para queries pesadas (10 minutos)
  timeout: 600000,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // httpsAgent: agent
});

export default config;
